// ROFF Goods 送料計算ロジック
// 実際のヤマト運輸運賃表(2025年10月1日改定・関東発)に更新したもの
// トートバッグ=80サイズ、ロフミスト=60サイズで発送し、どちらも地域別送料とする
// このファイルで元の src/utils/shipping.ts を上書きしてください

// トートバッグの商品ID(Notion側の商品IDに合わせて後で調整してください)
const TOTE_BAG_ID = 'tote-bag';
const CLEAR_FILE_ID = 'clear-file';
const MIST_ID_PREFIX = 'roff-mist-';

// ヤマト運輸 宅急便 80サイズ 地域別送料（関東・千葉県発、税込）
// トートバッグはこのサイズで発送
// 出典: https://www.yamato-hd.co.jp/important/pdf/info_250501_1.pdf (2025年10月1日運用開始・現金決済運賃表)
const YAMATO_80_RATES: Record<string, number> = {
  // 関東（1,230円）
  '東京都': 1230, '神奈川県': 1230, '埼玉県': 1230, '千葉県': 1230,
  '茨城県': 1230, '栃木県': 1230, '群馬県': 1230, '山梨県': 1230,
  // 信越（1,230円）
  '新潟県': 1230, '長野県': 1230,
  // 北陸（1,230円）
  '富山県': 1230, '石川県': 1230, '福井県': 1230,
  // 中部（1,230円）
  '静岡県': 1230, '愛知県': 1230, '岐阜県': 1230, '三重県': 1230,
  // 南東北（1,230円）
  '福島県': 1230, '宮城県': 1230, '山形県': 1230,
  // 北東北（1,350円）
  '岩手県': 1350, '秋田県': 1350, '青森県': 1350,
  // 関西（1,350円）
  '大阪府': 1350, '京都府': 1350, '滋賀県': 1350,
  '奈良県': 1350, '和歌山県': 1350, '兵庫県': 1350,
  // 中国（1,480円）
  '岡山県': 1480, '広島県': 1480, '鳥取県': 1480,
  '島根県': 1480, '山口県': 1480,
  // 四国（1,480円）
  '香川県': 1480, '徳島県': 1480, '愛媛県': 1480, '高知県': 1480,
  // 九州（1,740円）
  '福岡県': 1740, '佐賀県': 1740, '長崎県': 1740,
  '熊本県': 1740, '大分県': 1740, '宮崎県': 1740, '鹿児島県': 1740,
  // 北海道（1,740円）
  '北海道': 1740,
  // 沖縄（2,070円）
  '沖縄県': 2070,
};

// ヤマト運輸 宅急便 60サイズ 地域別送料（関東・千葉県発、税込）
// ロフミストはこのサイズで発送
// 出典: https://www.yamato-hd.co.jp/important/pdf/info_250501_1.pdf (2025年10月1日運用開始・現金決済運賃表)
const YAMATO_60_RATES: Record<string, number> = {
  // 関東（940円）
  '東京都': 940, '神奈川県': 940, '埼玉県': 940, '千葉県': 940,
  '茨城県': 940, '栃木県': 940, '群馬県': 940, '山梨県': 940,
  // 信越（940円）
  '新潟県': 940, '長野県': 940,
  // 北陸（940円）
  '富山県': 940, '石川県': 940, '福井県': 940,
  // 中部（940円）
  '静岡県': 940, '愛知県': 940, '岐阜県': 940, '三重県': 940,
  // 南東北（940円）
  '福島県': 940, '宮城県': 940, '山形県': 940,
  // 北東北（1,060円）
  '岩手県': 1060, '秋田県': 1060, '青森県': 1060,
  // 関西（1,060円）
  '大阪府': 1060, '京都府': 1060, '滋賀県': 1060,
  '奈良県': 1060, '和歌山県': 1060, '兵庫県': 1060,
  // 中国（1,190円）
  '岡山県': 1190, '広島県': 1190, '鳥取県': 1190,
  '島根県': 1190, '山口県': 1190,
  // 四国（1,190円）
  '香川県': 1190, '徳島県': 1190, '愛媛県': 1190, '高知県': 1190,
  // 九州（1,460円）
  '福岡県': 1460, '佐賀県': 1460, '長崎県': 1460,
  '熊本県': 1460, '大分県': 1460, '宮崎県': 1460, '鹿児島県': 1460,
  // 北海道（1,460円）
  '北海道': 1460,
  // 沖縄（1,460円）
  '沖縄県': 1460,
};

// クリックポスト全国一律
const CLICKPOST_RATE = 240;

export type ShippingMethod = 'yamato80' | 'yamato60' | 'clickpost';

export function hasToteBag(productIds: string[]): boolean {
  return productIds.includes(TOTE_BAG_ID);
}

export function hasMist(productIds: string[]): boolean {
  return productIds.some(id => id.startsWith(MIST_ID_PREFIX));
}

function hasBulkyItem(productIds: string[]): boolean {
  return productIds.includes(TOTE_BAG_ID) || productIds.includes(CLEAR_FILE_ID);
}

// 配送サイズのルール:
// ・ミストのみ / ミスト+ポーチ+クリーナー(小物のみ) → 60サイズ
// ・ミスト+クリアファイル or トート(かさばる商品を含む) → 80サイズ
// ・ミストを含まない場合、トートバッグ単体は80サイズ、それ以外はクリックポスト
export function getShippingMethod(productIds: string[]): ShippingMethod {
  if (hasMist(productIds)) {
    return hasBulkyItem(productIds) ? 'yamato80' : 'yamato60';
  }
  if (hasToteBag(productIds)) return 'yamato80';
  return 'clickpost';
}

export function getShippingMethodLabel(productIds: string[]): string {
  const method = getShippingMethod(productIds);
  if (method === 'yamato80' || method === 'yamato60') return 'ヤマト';
  return '日本郵便';
}

export function calculateShipping(productIds: string[], prefecture?: string): number {
  const method = getShippingMethod(productIds);
  if (!prefecture) return 0;
  if (method === 'yamato80') {
    return YAMATO_80_RATES[prefecture] ?? 1480; // 万一未登録の県があれば中国/四国相当を仮適用
  }
  if (method === 'yamato60') {
    return YAMATO_60_RATES[prefecture] ?? 1190; // 万一未登録の県があれば中国/四国相当を仮適用
  }
  return CLICKPOST_RATE;
}
